import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import CustomButton from '../CommonComp/Buttons/CustomButton';

const ViewAdminLogsModal = ({ open, setOpen, data }) => {
  const processValues = (oldVal, newVal) => {
    const oldData = oldVal || {};
    const newData = newVal || {};
    const allKeys = new Set();

    const normalize = (obj) => {
      let result = {};
      for (let key in obj) {
        const keyParts = key.split('|').map((k) => k.trim());
        const valueParts = String(obj[key])
          .split('|')
          .map((v) => v.trim());

        keyParts.forEach((k, i) => {
          result[k] = valueParts[i] ?? 'N/A';
          allKeys.add(k);
        });
      }
      return result;
    };

    const finalOld = normalize(oldData);
    const finalNew = normalize(newData);

    return { oldData: finalOld, newData: finalNew, allKeys: [...allKeys] };
  };

  const { oldData, newData, allKeys } = processValues(
    data?.old_value,
    data?.new_value,
  );

  return (
    <Dialog maxWidth="md" open={open} onClose={() => setOpen(false)} fullWidth>
      <DialogTitle variant="h3" padding={3} fontWeight="bold">
        Admin Log Details
      </DialogTitle>
      <DialogContent>
        <CustomBox padding={1}>
          <Grid container spacing={2}>
            <Grid container item spacing={2}>
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Field
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Old Value
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  New Value
                </Typography>
              </Grid>
            </Grid>

            {allKeys.length > 0 ? (
              allKeys.map((key) => (
                <Grid
                  container
                  item
                  spacing={2}
                  key={key}
                  alignItems="flex-start"
                >
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      textTransform="capitalize"
                    >
                      {key.replace(/_/g, ' ')}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      bgcolor={
                        oldData[key] !== newData[key]
                          ? '#ffebee'
                          : 'transparent'
                      }
                      p={1}
                      borderRadius={1}
                      minHeight="40px"
                      display="flex"
                      alignItems="center"
                    >
                      <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
                        {String(oldData[key] ?? 'N/A')}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      bgcolor={
                        oldData[key] !== newData[key]
                          ? '#e8f5e9'
                          : 'transparent'
                      }
                      p={1}
                      borderRadius={1}
                      minHeight="40px"
                      display="flex"
                      alignItems="center"
                    >
                      <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
                        {String(newData[key] ?? 'N/A')}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="body1" mt={3} textAlign="center">
                  No changes recorded.
                </Typography>
              </Grid>
            )}
          </Grid>
        </CustomBox>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}>
          <CustomButton onClick={() => setOpen(false)}>Close</CustomButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAdminLogsModal;